import { transition, trigger, useAnimation } from '@angular/animations';
import { Component } from '@angular/core';
import { fadeInRight } from 'ng-animate';

@Component({
  selector: 'our-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
  animations: [
    trigger('fadeInRight', [transition('* => *', useAnimation(fadeInRight))])]
})
export class ServicesComponent {

  fadeInRight: any;

  public language: string = document.URL.split('/')[3];

  constructor() {

  }

  // ngAfterViewInit() {
  //   this.sound.turnservice-sound();
  // }

}
